<div class="p-4">
  <h1 class="mb-6 text-2xl font-semibold">Registration DB Logs</h1>

  <div class="mb-8 mt-4 flex flex-wrap gap-4">
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Account Number</span>
      </div>
      <input
        type="text"
        class="input input-bordered"
        [(ngModel)]="accountNumber"
        (keydown.enter)="search(); $event.preventDefault()"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Changed by (user)</span>
      </div>
      <input
        type="text"
        class="input input-bordered"
        [(ngModel)]="createdBy"
        (keydown.enter)="search(); $event.preventDefault()"
        placeholder="Email"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">From date</span>
      </div>
      <input
        type="date"
        class="input input-bordered"
        [(ngModel)]="createdAfter"
      />
    </label>
    <label class="form-control min-w-[12rem]">
      <div class="label">
        <span class="label-text">Through date</span>
      </div>
      <input
        type="date"
        class="input input-bordered"
        [(ngModel)]="createdBefore"
      />
    </label>

    <div class="flex flex-col items-end justify-end gap-2 sm:flex-row">
      <button type="button" class="btn btn-primary" (click)="search()">
        Search
      </button>
      <button type="button" class="btn btn-neutral" (click)="clearFilters()">
        Clear
      </button>
      <button
        type="button"
        class="btn btn-neutral"
        [disabled]="loading || exporting || totalCount === 0"
        (click)="exportCsv()"
      >
        @if (exporting) {
          <span class="loading loading-spinner loading-sm"></span>
        }
        Export CSV
      </button>
    </div>
  </div>

  @if (error) {
    <div class="alert alert-error mb-4">{{ error }}</div>
  }

  @if (loading) {
    <div class="flex justify-center py-12">
      <span class="loading loading-spinner loading-lg"></span>
    </div>
  } @else {
    <div class="mb-4 text-sm opacity-80">
      {{ totalCount }} record(s) · page {{ currentPage }} of {{ totalPages }}
    </div>
    <div class="overflow-x-auto rounded-lg border border-base-content/20">
      <table
        class="table table-zebra table-pin-rows"
        [ngClass]="{
          'table-lg': tableSpacing === 'comfortable',
          'table-md': tableSpacing === 'normal',
          'table-xs': tableSpacing === 'compact',
        }"
      >
        <thead>
          <tr>
            <th>Account #</th>
            <th>User</th>
            <th>Action</th>
            <th>Unique ID</th>
            <th>Computer Name</th>
            <th>GUID</th>
            <th>Features</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          @for (row of rows; track row.id) {
            <tr>
              <td>{{ row.account_number || '—' }}</td>
              <td>{{ row.user_email }}</td>
              <td>{{ row.action }}</td>
              <td class="font-mono text-xs">{{ row.unique_id || '—' }}</td>
              <td class="font-mono text-xs">{{ row.computer_name || '—' }}</td>
              <td class="font-mono text-xs">{{ row.guid || '—' }}</td>
              <td class="break-words break-all font-mono text-xs">
                {{ row.features || '—' }}
              </td>
              <td class="whitespace-nowrap">
                {{ row.created_at | date: 'short' }}
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="8" class="text-center opacity-70">No logs found.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      class="mt-6 block"
      [spacing]="tableSpacing"
      [pageSize]="pageSize"
      [currentPage]="currentPage"
      [totalPages]="totalPages"
      (pageChanged)="onPageChanged($event)"
      (settingsChanged)="saveSettings($event); search()"
    ></app-pagination>
  }
</div>
